import {
  FETCH_RESULTS,
  FETCH_RESULTS_SUCCESS,
  FETCH_RESULTS_FAIL,
  FETCH_RESULT,
  FETCH_RESULT_SUCCESS,
  FETCH_RESULT_FAIL,
} from 'config/types';

import { find, findIndex } from 'lodash';

const INITIAL_STATE = {
  isLoading: false,
  results: [],
  currentResult: undefined
};

export default function results(state=INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_RESULTS:
      return {...state, isLoading: true};
    case FETCH_RESULTS_SUCCESS: {
      return {...state, results: action.payload, isLoading: false};
    }
    case FETCH_RESULTS_FAIL:
      return {...state, isLoading: false};
    case FETCH_RESULT:
      return {...state, isLoading: true};
    case FETCH_RESULT_SUCCESS: {
      return {...state, currentResult: action.payload, isLoading: false};
    }
    case FETCH_RESULT_FAIL:
      return {...state, isLoading: false};
    default:
      return state;
  }
}
